import api from './api';

class NiboOAuthService {
  // Iniciar processo de autorização OAuth2
  static initiateAuth() {
    const clientId = process.env.REACT_APP_NIBO_CLIENT_ID;
    const redirectUri = window.location.origin;
    // Gerar um 'state' único a cada chamada
    const state = `${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
    const authUrl = `${process.env.REACT_APP_NIBO_AUTH_URL}?client_id=${clientId}&scope=&response_type=code&state=${state}&redirect_uri=${redirectUri}`;
  
    const top = (window.screen.height / 2) - 300;
    const left = (window.screen.width / 2) - 300;
    const authWindow = window.open(authUrl, 'NiboOAuth', `width=600,height=600,top=${top},left=${left}`);
  
    return new Promise((resolve, reject) => {
      const handleAuthMessage = (event) => {
        if (event.origin !== window.location.origin) return;
    
        const { code } = event.data || {};
        if (!code) return;
    
        // Fechar janela de autenticação
        authWindow?.close();
        
        // Limpar o event listener
        window.removeEventListener('message', handleAuthMessage);
        
        resolve(code);
      };
    
      window.addEventListener('message', handleAuthMessage);
      
      // Timeout para rejeitar se não receber resposta
      setTimeout(() => {
        window.removeEventListener('message', handleAuthMessage);
        reject(new Error('Timeout na autorização OAuth2'));
      }, 300000); // 5 minutos
    });
  }

  // Buscar empresas/organizações do usuário usando o endpoint do back-end
  static async getNiboEmpresas(code, tenantId) {
    try {
      const host = window.location.origin;
      const response = await api.get(`/niboEmpresas/${tenantId}`, {
        params: {
          code,
          host,
        },
      });
      
      if (response.status === 200) {
        return {
          owner: response.data.owner,
          organizations: response.data.organizations.map(org => ({
            label: org.name,
            value: org.id
          }))
        };
      } else {
        throw new Error(`Erro ao buscar empresas do Nibo: status ${response.status}`);
      }
    } catch (error) {
      console.error('Erro ao buscar empresas:', error);
      throw new Error('Não foi possível buscar as empresas do Nibo. Tente novamente.');
    }
  }

  // Processo completo de autenticação
  static async completeAuthWithTenant(tenantId) {
    try {
      // 1. Iniciar autorização
      const code = await this.initiateAuth();
      
      // 2. Buscar empresas usando o método existente
      const result = await this.getNiboEmpresas(code, tenantId);
      
      return result;
    } catch (error) {
      console.error('Erro no processo de autenticação:', error);
      throw new Error('Falha na autenticação com o Nibo. Por favor, tente novamente.');
    }
  }

  // Criar integração com Nibo
  static async createIntegration(tenantId, owner, empresas) {
    try {
      const response = await api.post('/nibo/createIntegration', {
        tenantId,
        credentials: {
          owner,
          empresas
        }
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Erro ao criar integração com Nibo: status ${response.status}`);
      }
    } catch (error) { 
      console.error('Erro ao criar integração:', error);
      throw new Error('Não foi possível criar a integração com o Nibo. Tente novamente.');
    }
  }

  // Excluir integração com Nibo
  static async deleteIntegration(tenantId, externalId, owner) {
    try {
      const response = await api.delete('/nibo/deleteIntegration', {
        data: {
          tenantId,
          externalId,
          owner
        }
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Erro ao excluir integração com Nibo: status ${response.status}`);
      }
    } catch (error) {
      console.error('Erro ao excluir integração:', error);
      throw new Error('Não foi possível excluir a integração com o Nibo. Tente novamente.');
    }
  }
}

export default NiboOAuthService;


  {/*
  static async exchangeCodeForToken(code) {
    try {
      const response = await api.post('/nibo/oauth/token', {
        code,
        grant_type: 'authorization_code',
        client_id: process.env.REACT_APP_NIBO_CLIENT_ID,
        redirect_uri: window.location.origin
      });
      
      return response.data;
    } catch (error) {
      console.error('Erro ao trocar código por token:', error);
      throw error;
    }
  }
    */}